/**
 * Dopo l'acquisto di Pro (#35, #36). Lo store conferma il pagamento, poi il Pro
 * arriva col webhook di RevenueCat dopo qualche secondo: senza questa modale
 * l'app sembrava non fare niente (prova su iPhone del 21/10).
 *
 * stato: "attesa" (pagamento confermato, Pro in arrivo), "attivo" (Pro sul
 * profilo), "lento" (dopo l'attesa massima il Pro non è ancora arrivato).
 */
import React from "react";
import { useTranslation } from "react-i18next";

export default function ProAttivazioneModal({ stato, onClose }) {
  const { t } = useTranslation();
  if (!stato) return null;

  const overlayStyle = {
    position: "fixed", inset: 0,
    background: "rgba(0,0,0,0.5)",
    backdropFilter: "blur(8px)", WebkitBackdropFilter: "blur(8px)",
    zIndex: 335,
    display: "flex", alignItems: "center", justifyContent: "center",
    padding: 24,
  };
  const cardStyle = {
    background: "var(--color-surface)",
    borderRadius: "2rem", padding: 32,
    maxWidth: 420, width: "100%",
    boxShadow: "0 24px 64px rgba(0,0,0,0.18)",
    textAlign: "center",
  };
  const badgeStyle = {
    width: 72, height: 72, borderRadius: 24, margin: "0 auto 20px",
    background: "linear-gradient(135deg, var(--color-primary), var(--color-primaryBright))",
    boxShadow: "0 8px 24px var(--color-glow)",
    display: "flex", alignItems: "center", justifyContent: "center",
    fontSize: 32, color: "var(--color-onPrimary)",
    animation: stato === "attivo" ? "pop-in 420ms cubic-bezier(.22,1,.36,1)" : "none",
  };
  const spinnerStyle = {
    width: 34, height: 34, borderRadius: "50%",
    border: "4px solid rgba(255,255,255,0.35)",
    borderTopColor: "var(--color-onPrimary)",
    animation: "spin-slow 900ms linear infinite",
  };
  const titleStyle = {
    fontFamily: "var(--font-display)", fontSize: 24, fontWeight: 800,
    color: "var(--color-text)", margin: "0 0 10px",
  };
  const bodyStyle = {
    fontFamily: "var(--font-body)", fontSize: 15, lineHeight: 1.6,
    color: "var(--color-textMuted)", margin: "0 0 24px",
  };
  const ctaStyle = {
    width: "100%", padding: "14px 20px", border: "none", borderRadius: 16,
    fontFamily: "var(--font-body)", fontSize: 16, fontWeight: 700, cursor: "pointer",
    background: "linear-gradient(135deg, var(--color-primary), var(--color-primaryBright))",
    color: "var(--color-onPrimary)", boxShadow: "0 8px 24px var(--color-glow)",
  };

  const testi = {
    attesa: { titolo: t("ui.proAttivazione.waitingTitle"), corpo: t("ui.proAttivazione.waitingBody") },
    attivo: { titolo: t("ui.proAttivazione.doneTitle"), corpo: t("ui.proAttivazione.doneBody"), cta: t("ui.proAttivazione.doneCta") },
    lento: { titolo: t("ui.proAttivazione.slowTitle"), corpo: t("ui.proAttivazione.slowBody"), cta: t("ui.proAttivazione.slowCta") },
  }[stato];
  if (!testi) return null;

  return (
    <div style={overlayStyle}>
      <div style={cardStyle} role="dialog" aria-modal="true" aria-live="polite" data-testid={`pro-attivazione-${stato}`}>
        <div style={badgeStyle} aria-hidden="true">
          {stato === "attesa" ? <span style={spinnerStyle} /> : stato === "attivo" ? "✨" : "✓"}
        </div>
        <h2 style={titleStyle}>{testi.titolo}</h2>
        <p style={{ ...bodyStyle, marginBottom: testi.cta ? 24 : 0 }}>{testi.corpo}</p>
        {testi.cta && (
          <button type="button" onClick={onClose} style={ctaStyle} data-testid="pro-attivazione-cta">
            {testi.cta}
          </button>
        )}
      </div>
    </div>
  );
}
